var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      attrs: { closable: false, size: "large" },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c("sui-icon", {
        attrs: { name: "close" },
        on: { click: _vm.toggleSupervisedPersons },
      }),
      _c(
        "sui-modal-header",
        [
          _c(
            "sui-menu",
            {
              staticStyle: { "box-shadow": "none !important" },
              attrs: { compact: "" },
            },
            [
              _c(
                "sui-menu-item",
                {
                  tag: "a",
                  on: { click: _vm.filterAttestedSupervisedPersons },
                },
                [
                  _c("sui-icon", { attrs: { name: "users" } }),
                  _vm._v(" Attested "),
                  _c("sui-label", { attrs: { color: "olive", floating: "" } }, [
                    _vm._v(" " + _vm._s(_vm.numberOfAttestedPersons) + " "),
                  ]),
                ],
                1
              ),
              _c(
                "sui-menu-item",
                { tag: "a", on: { click: _vm.filterPendingSupervisedPersons } },
                [
                  _c("sui-icon", { attrs: { name: "users" } }),
                  _vm._v(" Pending "),
                  _c("sui-label", { attrs: { color: "brown", floating: "" } }, [
                    _vm._v(" " + _vm._s(_vm.numberOfPendingPersons) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("sui-button", {
            attrs: { basic: "", icon: "undo", floated: "right" },
            on: { click: _vm.resetList },
          }),
        ],
        1
      ),
      _c(
        "sui-modal-content",
        { attrs: { scrolling: "" } },
        [
          _c(
            "sui-table",
            { attrs: { basic: "very", celled: "", selectable: "" } },
            [
              _c(
                "sui-table-header",
                [
                  _c(
                    "sui-table-row",
                    [
                      _c("sui-table-header-cell"),
                      _vm._l(_vm.columns, function (column, index) {
                        return _c("sui-table-header-cell", { key: index }, [
                          _vm._v(" " + _vm._s(column) + " "),
                        ])
                      }),
                      _c("sui-table-header-cell"),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.persons
                ? _c(
                    "sui-table-body",
                    _vm._l(_vm.persons, function (person, index) {
                      return _c(
                        "sui-table-row",
                        { key: person.id },
                        [
                          _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                            _vm._v(_vm._s(index + 1)),
                          ]),
                          _c("sui-table-cell", [
                            _vm._v(
                              _vm._s(person.first_name) +
                                " " +
                                _vm._s(person.last_name)
                            ),
                          ]),
                          _c("sui-table-cell", [
                            _vm._v(_vm._s(person.first_name)),
                          ]),
                          _c("sui-table-cell", [
                            _vm._v(_vm._s(person.last_name)),
                          ]),
                          _c("sui-table-cell", [_vm._v(_vm._s(person.email))]),
                          person.has_attested
                            ? _c(
                                "sui-table-cell",
                                { attrs: { positive: "" } },
                                [
                                  _c("sui-icon", { attrs: { name: "check" } }),
                                  _vm._v(" Attested "),
                                ],
                                1
                              )
                            : _vm._e(),
                          !person.has_attested
                            ? _c(
                                "sui-table-cell",
                                { attrs: { warning: "" } },
                                [
                                  _c("sui-icon", {
                                    attrs: { name: "attention" },
                                  }),
                                  _vm._v(" Not Submitted "),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("sui-table-cell", [
                            _vm._v(
                              _vm._s(_vm.toDatetime(person.attested_date))
                            ),
                          ]),
                          _c(
                            "sui-table-cell",
                            [
                              _c("SendEmail", {
                                attrs: {
                                  supervisedPersonUserId: person.user_id,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          Array.isArray(_vm.persons) && !_vm.persons.length
            ? _c("NoItemsFoundListMessage")
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }